import ProfileSetting from '@/Component/Profile/ProfileSetting'
import SavedCards from '@/Component/Profile/ProfileSetting/SavedCards'

const SavedCardsPage = () => {
    return (
        <ProfileSetting activeTab="saved-cards">
            <SavedCards />
        </ProfileSetting>
    )
}

export default SavedCardsPage
